// Tutor Voice and Accent Selection Data
// This file contains data for tutor voice options and accent preferences

export const tutorVoiceOptions = [
  {
    id: 'us_american_cheerful',
    countryCode: 'US',
    accentName: {
      traditional: '美式口音',
      simplified: '美式口音',
      english: 'American Accent'
    },
    description: {
      traditional: '開朗尖銳快速',
      simplified: '开朗尖锐快速',
      english: 'Cheerful Sharp Fast'
    },
    voiceType: 'female',
    isSelected: true,
    selectionColor: 'pink', // pink circle
    category: 'american',
    characteristics: {
      speed: 'fast',
      tone: 'cheerful',
      clarity: 'sharp',
      energy: 'high'
    },
    samplePhrase: 'Hello! How are you today?',
    difficulty: 'beginner',
    popularity: 95
  },
  {
    id: 'us_american_upbeat',
    countryCode: 'US',
    accentName: {
      traditional: '美式口音',
      simplified: '美式口音',
      english: 'American Accent'
    },
    description: {
      traditional: '樂觀活潑熱情',
      simplified: '乐观活泼热情',
      english: 'Upbeat Lively Enthusiastic'
    },
    voiceType: 'female',
    isSelected: true,
    selectionColor: 'pink', // pink circle
    category: 'american',
    characteristics: {
      speed: 'medium',
      tone: 'upbeat',
      clarity: 'clear',
      energy: 'high'
    },
    samplePhrase: 'Great to see you! Let\'s learn together!',
    difficulty: 'beginner',
    popularity: 88
  },
  {
    id: 'us_american_lively',
    countryCode: 'US',
    accentName: {
      traditional: '美式口音',
      simplified: '美式口音',
      english: 'American Accent'
    },
    description: {
      traditional: '活潑興奮有趣',
      simplified: '活泼兴奋有趣',
      english: 'Lively Excited Fun'
    },
    voiceType: 'male',
    isSelected: true,
    selectionColor: 'blue', // blue circle
    category: 'american',
    characteristics: {
      speed: 'medium',
      tone: 'lively',
      clarity: 'clear',
      energy: 'medium'
    },
    samplePhrase: 'Hey there! Ready for some fun learning?',
    difficulty: 'beginner',
    popularity: 82
  },
  {
    id: 'au_australian_cheerful',
    countryCode: 'AU',
    accentName: {
      traditional: '澳洲口音',
      simplified: '澳洲口音',
      english: 'Australian Accent'
    },
    description: {
      traditional: '開朗尖銳快速',
      simplified: '开朗尖锐快速',
      english: 'Cheerful Sharp Fast'
    },
    voiceType: 'male',
    isSelected: true,
    selectionColor: 'blue', // blue circle
    category: 'australian',
    characteristics: {
      speed: 'fast',
      tone: 'cheerful',
      clarity: 'sharp',
      energy: 'high'
    },
    samplePhrase: 'G\'day mate! How\'s it going?',
    difficulty: 'intermediate',
    popularity: 75
  },
  {
    id: 'gb_british_polite',
    countryCode: 'GB',
    accentName: {
      traditional: '英式口音',
      simplified: '英式口音',
      english: 'British Accent'
    },
    description: {
      traditional: '禮貌優雅清晰',
      simplified: '礼貌优雅清晰',
      english: 'Polite Elegant Clear'
    },
    voiceType: 'female',
    isSelected: true,
    selectionColor: 'pink', // pink circle
    category: 'british',
    characteristics: {
      speed: 'slow',
      tone: 'polite',
      clarity: 'clear',
      energy: 'medium'
    },
    samplePhrase: 'Good morning! Shall we begin our lesson?',
    difficulty: 'intermediate',
    popularity: 90
  },
  {
    id: 'gb_british_wise',
    countryCode: 'GB',
    accentName: {
      traditional: '英式口音',
      simplified: '英式口音',
      english: 'British Accent'
    },
    description: {
      traditional: '智慧溫和穩重',
      simplified: '智慧温和稳重',
      english: 'Wise Gentle Steady'
    },
    voiceType: 'male',
    isSelected: true,
    selectionColor: 'blue', // blue circle
    category: 'british',
    characteristics: {
      speed: 'slow',
      tone: 'wise',
      clarity: 'clear',
      energy: 'low'
    },
    samplePhrase: 'Now then, let\'s take our time with this.',
    difficulty: 'advanced',
    popularity: 85
  },
  {
    id: 'de_german_precise',
    countryCode: 'DE',
    accentName: {
      traditional: '德式口音',
      simplified: '德式口音',
      english: 'German Accent'
    },
    description: {
      traditional: '精確清晰有幫助',
      simplified: '精确清晰有帮助',
      english: 'Precise Clear Helpful'
    },
    voiceType: 'female',
    isSelected: true,
    selectionColor: 'pink', // pink circle
    category: 'german',
    characteristics: {
      speed: 'medium',
      tone: 'precise',
      clarity: 'very_clear',
      energy: 'medium'
    },
    samplePhrase: 'Very good! Now let\'s practice this step by step.',
    difficulty: 'intermediate',
    popularity: 78
  },
  {
    id: 'in_indian_warm',
    countryCode: 'IN',
    accentName: {
      traditional: '印度口音',
      simplified: '印度口音',
      english: 'Indian Accent'
    },
    description: {
      traditional: '溫暖友善耐心',
      simplified: '温暖友善耐心',
      english: 'Warm Kind Patient'
    },
    voiceType: 'female',
    isSelected: true,
    selectionColor: 'pink', // pink circle
    category: 'indian',
    characteristics: {
      speed: 'slow',
      tone: 'warm',
      clarity: 'clear',
      energy: 'medium'
    },
    samplePhrase: 'Hello! Don\'t worry, we\'ll take it slowly.',
    difficulty: 'beginner',
    popularity: 92
  },
  {
    id: 'in_indian_helpful',
    countryCode: 'IN',
    accentName: {
      traditional: '印度口音',
      simplified: '印度口音',
      english: 'Indian Accent'
    },
    description: {
      traditional: '有幫助平靜溫和',
      simplified: '有帮助平静温和',
      english: 'Helpful Calm Gentle'
    },
    voiceType: 'male',
    isSelected: true,
    selectionColor: 'blue', // blue circle
    category: 'indian',
    characteristics: {
      speed: 'slow',
      tone: 'helpful',
      clarity: 'clear',
      energy: 'low'
    },
    samplePhrase: 'No problem at all! Let me explain this clearly.',
    difficulty: 'beginner',
    popularity: 87
  }
];

export const voiceCategories = [
  {
    id: 'american',
    name: {
      traditional: '美式英語',
      simplified: '美式英语',
      english: 'American English'
    },
    flag: '🇺🇸',
    description: {
      traditional: '標準美式發音和語調',
      simplified: '标准美式发音和语调',
      english: 'Standard American pronunciation and intonation'
    }
  },
  {
    id: 'british',
    name: {
      traditional: '英式英語',
      simplified: '英式英语',
      english: 'British English'
    },
    flag: '🇬🇧',
    description: {
      traditional: '傳統英式發音和語調',
      simplified: '传统英式发音和语调',
      english: 'Traditional British pronunciation and intonation'
    }
  },
  {
    id: 'australian',
    name: {
      traditional: '澳洲英語',
      simplified: '澳洲英语',
      english: 'Australian English'
    },
    flag: '🇦🇺',
    description: {
      traditional: '獨特澳洲發音和語調',
      simplified: '独特澳洲发音和语调',
      english: 'Unique Australian pronunciation and intonation'
    }
  },
  {
    id: 'german',
    name: {
      traditional: '德式英語',
      simplified: '德式英语',
      english: 'German English'
    },
    flag: '🇩🇪',
    description: {
      traditional: '德式英語發音特點',
      simplified: '德式英语发音特点',
      english: 'German-accented English pronunciation'
    }
  },
  {
    id: 'indian',
    name: {
      traditional: '印度英語',
      simplified: '印度英语',
      english: 'Indian English'
    },
    flag: '🇮🇳',
    description: {
      traditional: '印度英語發音特點',
      simplified: '印度英语发音特点',
      english: 'Indian-accented English pronunciation'
    }
  }
];

export const voiceCharacteristics = {
  speed: [
    { id: 'slow', name: { traditional: '慢速', simplified: '慢速', english: 'Slow' } },
    { id: 'medium', name: { traditional: '中速', simplified: '中速', english: 'Medium' } },
    { id: 'fast', name: { traditional: '快速', simplified: '快速', english: 'Fast' } }
  ],
  tone: [
    { id: 'cheerful', name: { traditional: '開朗', simplified: '开朗', english: 'Cheerful' } },
    { id: 'upbeat', name: { traditional: '樂觀', simplified: '乐观', english: 'Upbeat' } },
    { id: 'lively', name: { traditional: '活潑', simplified: '活泼', english: 'Lively' } },
    { id: 'polite', name: { traditional: '禮貌', simplified: '礼貌', english: 'Polite' } },
    { id: 'wise', name: { traditional: '智慧', simplified: '智慧', english: 'Wise' } },
    { id: 'precise', name: { traditional: '精確', simplified: '精确', english: 'Precise' } },
    { id: 'warm', name: { traditional: '溫暖', simplified: '温暖', english: 'Warm' } },
    { id: 'helpful', name: { traditional: '有幫助', simplified: '有帮助', english: 'Helpful' } }
  ],
  energy: [
    { id: 'low', name: { traditional: '低能量', simplified: '低能量', english: 'Low Energy' } },
    { id: 'medium', name: { traditional: '中等能量', simplified: '中等能量', english: 'Medium Energy' } },
    { id: 'high', name: { traditional: '高能量', simplified: '高能量', english: 'High Energy' } }
  ]
};

// Get voice options by category
export const getVoiceOptionsByCategory = (category) => {
  if (category === 'all') {
    return tutorVoiceOptions;
  }
  return tutorVoiceOptions.filter(voice => voice.category === category);
};

// Get selected voice options
export const getSelectedVoiceOptions = () => {
  return tutorVoiceOptions.filter(voice => voice.isSelected);
};

// Get voice options by voice type
export const getVoiceOptionsByType = (voiceType) => {
  return tutorVoiceOptions.filter(voice => voice.voiceType === voiceType);
};

// Get voice options by selection color
export const getVoiceOptionsBySelectionColor = (color) => {
  return tutorVoiceOptions.filter(voice => voice.selectionColor === color);
};

// Update voice selection
export const updateVoiceSelection = (voiceId, isSelected) => {
  const voice = tutorVoiceOptions.find(v => v.id === voiceId);
  if (voice) {
    voice.isSelected = isSelected;
  }
};

// Get voice option by ID
export const getVoiceOptionById = (voiceId) => {
  return tutorVoiceOptions.find(voice => voice.id === voiceId);
};

// Get voice category by ID
export const getVoiceCategoryById = (categoryId) => {
  return voiceCategories.find(category => category.id === categoryId);
};

// Get voice characteristics by type
export const getVoiceCharacteristicsByType = (type) => {
  return voiceCharacteristics[type] || [];
};

// Get recommended voice options based on user preferences
export const getRecommendedVoiceOptions = (userPreferences) => {
  const { difficulty, energy, speed } = userPreferences;
  
  return tutorVoiceOptions.filter(voice => 
    voice.difficulty === difficulty &&
    voice.characteristics.energy === energy &&
    voice.characteristics.speed === speed
  );
};

// Get popular voice options
export const getPopularVoiceOptions = (limit = 5) => {
  return tutorVoiceOptions
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
};
